<div class="moneda-modal">

  <!-- header -->
  <div class="row">
    <div class="col-12">
      <h3 class="text-manax m-0 mb-4">
        <span class="pull-right">
          <button type="button" class="btn btn-link text-manax mr-2 p-0" (click)="setEditable()"
            *ngIf="readOnly && isDev">
            <i class="material-icons">edit</i> Modificar
          </button>
          <button mat-icon-button type="button" (click)="dialog.close()">
            <i class="material-icons">close</i>
          </button>
        </span>
        <span class="text-purple-manax text-capitalize title-modal">
          Feature
        </span>
      </h3>
    </div>
  </div>

  <!-- body -->
  <div class="row" *ngIf="loading">
    <div class="col-12 mb-4">
      <div class="d-flex justify-content-center">
        <div class="spinner-border" role="status">
          <span class="sr-only">Loading...</span>
        </div>
      </div>
    </div>
  </div>

  <div class="row" *ngIf="!loading">
    <div class="col-12">
      <form *ngIf="form" class="m-0" [formGroup]="form" (ngSubmit)="onSubmit()">
        <div class="row">
          <div class="col-md-12">
            <mat-form-field appearance="outline">
              <input matInput name="code" formControlName="code" placeholder="Codigo" type="text" #nameInput
                [readonly]="readOnly" [ngClass]="{ 'is-invalid': submitted && f['code'].errors }">
            </mat-form-field>
            <mat-error *ngIf="submitted && f['code'].errors?.['required']">
              Codigo Obligatorio
            </mat-error>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <mat-form-field appearance="outline">
              <input matInput name="name" formControlName="name" placeholder="Nombre" type="text" #nameInput
                [readonly]="readOnly" [ngClass]="{ 'is-invalid': submitted && f['name'].errors }">
            </mat-form-field>
            <mat-error *ngIf="submitted && f['name']?.errors?.['required']">
              Nombre Obligatorio
            </mat-error>
          </div>
        </div>
        <div class="row" *ngIf="feature._id && isDev">
          <div class="col-3">
            <label>
              Borrada? <br>
              <input name="isDeleted" formControlName="isDeleted" type="checkbox" [disabled]="readOnly">
            </label>
          </div>
          <div class="col-9">
            <mat-form-field appearance="outline">
              <input matInput placeholder="Id" type="text" [value]="feature._id" readonly>
            </mat-form-field>
          </div>
        </div>
        <div class="row" *ngIf="!readOnly">
          <div class="col-12 pt-4">
            <button mat-raised-button [disabled]="saving" type="submit" class="m-0 ml-1 pull-right btn btn-manax">
              <span *ngIf="saving" class="spinner-border spinner-border-sm mr-1"></span>
              Guardar
            </button>
            <button mat-raised-button type="button" class="m-0 ml-1 pull-right btn btn-link"
              (click)="dialog.close(false)">
              Cancelar
            </button>
          </div>
        </div>
      </form>
    </div>
  </div>
</div>